import { createContext } from 'react';

export const PrefsContext = createContext({});
